import React, { useEffect } from "react";
import { EDataTable } from "../../../components/EDataTable";
import { useVisitManagementStore } from "../../../store/visitStore";
import { DataTableColumn, SimpleFilter } from "../../../types";
import { FileBarChart, Clock, TrendingUp, CheckCircle, User, Calendar } from "lucide-react";
import { Tag } from "primereact/tag";

export const VisitReports = () => {
    // 1. Ayrıştırılmış store'u alıyoruz (Raporlar gerçekleşen rotalar üzerindendir)
    const visitManagement = useVisitManagementStore();

    // Sayfa açıldığında verileri varsayılan olarak yükle (ApiDataTable kendi fetch işlemini yapar)
    useEffect(() => {
        if (!visitManagement.routes.queryParams.sort || visitManagement.routes.queryParams.sort.length === 0) {
            visitManagement.routes.setQueryParams({
                ...visitManagement.routes.queryParams,
                pageIndex: 1,
                pageSize: 20,
                sort: [{ field: "plannedDate", dir: "desc" }]
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns: DataTableColumn<any>[] = [
        { 
            field: "plannedDate", 
            header: "Tarih", 
            width: "150px", 
            sortable: true,
            body: (r) => new Date(r.plannedDate).toLocaleDateString('tr-TR') 
        },
        { 
            field: "account.name", 
            header: "Müşteri", 
            width: "250px",
            body: (r) => (
                <div className="flex flex-col">
                    <span className="font-bold">{r.account?.name}</span>
                    <span className="text-xs text-gray-400">{r.employee?.firstName} {r.employee?.lastName}</span>
                </div>
            )
        },
        { 
            field: "status", 
            header: "Durum", 
            width: "150px",
            body: (r) => (
                <Tag 
                    value={r.status === 'COMPLETED' ? 'Tamamlandı' : 'Bekliyor'} 
                    severity={r.status === 'COMPLETED' ? 'success' : 'warning'} 
                />
            ) 
        },
        { 
            field: "actions", 
            header: "İşlem Özeti", 
            width: "300px",
            body: (r) => {
                const orders = r.actions?.filter((a: any) => a.type === 'ORDER') || [];
                const payments = r.actions?.filter((a: any) => a.type === 'PAYMENT') || [];
                
                const totalOrderAmount = orders.reduce((sum: number, curr: any) => sum + (curr.order?.totalAmount || 0), 0);
                
                return (
                    <div className="flex flex-wrap gap-2">
                        {orders.length > 0 && (
                            <span className="bg-orange-100 text-orange-700 px-2 py-1 rounded-md text-[10px] font-bold">
                                {orders.length} SİPARİŞ ({new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(totalOrderAmount)})
                            </span>
                        )}
                        {payments.length > 0 && (
                            <span className="bg-green-100 text-green-700 px-2 py-1 rounded-md text-[10px] font-bold">
                                {payments.length} TAHSİLAT
                            </span>
                        )}
                        {orders.length === 0 && payments.length === 0 && r.status === 'COMPLETED' && (
                            <span className="bg-gray-100 text-gray-500 px-2 py-1 rounded-md text-[10px]">Sadece Ziyaret</span>
                        )}
                    </div>
                );
            }
        }
    ];

    return (
        <div className="w-full space-y-6">
            {/* Üst Özet Kartları */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <ReportCard 
                    title="Toplam Ziyaret" 
                    value={visitManagement.routes.total.toString()} 
                    icon={<CheckCircle size={24}/>} 
                    color="text-green-600" 
               
                />
                <ReportCard 
                    title="Aktif Plasiyer" 
                    value="12" 
                    icon={<User size={24}/>} 
                    color="text-blue-600" 
                  
                />
                <ReportCard 
                    title="Siparişe Dönüş" 
                    value="%64" 
                    icon={<TrendingUp size={24}/>} 
                    color="text-purple-600" 
                   
                />
            </div>

            {/* Rapor Tablosu */}
            <div className=" ">
                <EDataTable<any>
                    tableKey="visit_reports"
                    dataKey="id"
                    useStore={() => visitManagement.routes}
                    title="Saha Performans Analizi"
                    columns={columns}
                    placeholder="Müşteri veya plasiyer ara..."
                    searchFields={[
                        { field: "account.name", operator: "contains" as SimpleFilter["operator"] },
                    ]}
                />
            </div>
        </div>
    );
};

// Alt Bileşen: Rapor Kartı
const ReportCard = ({ title, value, icon, color  }: any) => (
    <div className={` card2 shadow-sm   flex items-center gap-5 transition-transform hover:scale-[1.02]`}>
        <div className={`p-4   ${color} shadow-sm`}>
            {icon}
        </div>
        <div>
            <p className="text-sm   font-semibold uppercase tracking-wider">{title}</p>
            <p className={`text-3xl font-black ${color}`}>{value}</p>
        </div>
    </div>
);